import { render, staticRenderFns } from "./BatchShipping.vue?vue&type=template&id=3bc90ac2&scoped=true&"
import script from "./BatchShipping.vue?vue&type=script&lang=js&"
export * from "./BatchShipping.vue?vue&type=script&lang=js&"
import style0 from "./BatchShipping.vue?vue&type=style&index=0&id=3bc90ac2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc90ac2",
  null
  
)

export default component.exports